import type {PersonaPanelState} from "@Panels/persona-panel/persona-panel.types";
import type {Persona} from "@Panels/persona-panel/persona-library";
import {PersonaPanelStep} from "@Panels/persona-panel/persona-library";
import type {PayloadAction} from "@reduxjs/toolkit";
import {createSlice} from "@reduxjs/toolkit";
import {
    TransitionDirection
} from "@Panels/transitionable-panel-v2/transitionable-panel-v2.types";
import {savePersona} from "@Panels/persona-panel/persona-panel-thunk";

const initialState: PersonaPanelState = {
    isWaitingForAJAXResponse: false,
    currentStep: PersonaPanelStep.SELECT_PERSONA,
    selectedPersona: null,
    transitionDirection: TransitionDirection.FORWARD,
};

export const personaPanelSlice = createSlice({
    name: 'personaPanel',
    initialState,
    reducers: {
        updateSelectedPersona: (state, {payload}: PayloadAction<Persona | null>) => {
            state.selectedPersona = payload;
        },
        updateStep: (state, {payload}: PayloadAction<{
            step: PersonaPanelStep;
            direction: TransitionDirection;
        }>) => {
            state.currentStep = payload.step;
            state.transitionDirection = payload.direction;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(savePersona.pending, (state) => {
            state.isWaitingForAJAXResponse = true;
        });
        builder.addCase(savePersona.fulfilled, (state) => {
            state.isWaitingForAJAXResponse = false;
        });
    }
});

export const {updateSelectedPersona, updateStep} = personaPanelSlice.actions;
export const personaPanelReducer = personaPanelSlice.reducer;